import request from '@/utils/request'

// 查询类型列表
export function listTableCategory(data) {
  return request({
    url: '/sysDemandType/list',
    method: 'post',
    data,
  })
}

// 查询类型列表
export function listTableCategory2(data) {
  return request({
    url: '/sysDemandType/list',
    method: 'post',
    data,
  })
}
// 新增类型
export function addTable(data) {
  return request({
    url: '/sysDemandType/insert',
    method: 'post',
    data: data,
  })
}

// 修改类型
export function updateTable(data) {
  return request({
    url: '/sysDemandType/update',
    method: 'post',
    data: data,
  })
}

// 删除类型
export function delTable(data) {
  return request({
    url: `/sysDemandType/delete/?id=${data}`,
    method: 'get',
  })
}
